import { toast } from "react-toastify";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as walletAction from 'store/entities/wallet/action'
import * as notificationAction from 'store/entities/notification/action'
import * as accountActions from "store/auth/account/action";
import Maybe from "components/__new/common/Maybe";
import { OptInYield } from "./OptInYield";
import { OptOutYield } from "./OptOutYield";

const OptInOutYield = (props) => {
    const {isOpen, setIsOpen, employer} = props;
    const dispatch = useDispatch();
    const { optInOutYield, optInOutYieldLoading } = useSelector(s => s.entities.wallet)
    const [hasAgreed, setHasAgreed] = useState(false);
    
    const handleOptInOutYield = () => {
        dispatch(walletAction.optInOutYield());
    }

    useEffect(() => {
        if (optInOutYield?.status === "success") {
            dispatch(accountActions.getEmployerInfo());
            toast.success(optInOutYield?.message)
            setHasAgreed(false);
            setIsOpen(false);
            dispatch(walletAction.resetOptInOutYield());
            dispatch(notificationAction.getAllNotifications());
        }
    }, [optInOutYield, dispatch, setIsOpen]);

    return (
       <>
            <Maybe condition={!employer?.shouldEarnYield}>
                <OptInYield  
                    isOpen={isOpen} 
                    setIsOpen={setIsOpen} 
                    employer={employer} 
                    hasAgreed={hasAgreed} 
                    setHasAgreed={setHasAgreed} 
                    handleOptInOutYield={handleOptInOutYield} optInOutYieldLoading={optInOutYieldLoading}
                />
            </Maybe>
            <Maybe condition={employer?.shouldEarnYield}>
                <OptOutYield  
                    isOpen={isOpen} 
                    setIsOpen={setIsOpen} 
                    employer={employer} 
                    handleOptInOutYield={handleOptInOutYield} optInOutYieldLoading={optInOutYieldLoading}
                />
            </Maybe>
       </>
    )
}


export default OptInOutYield;